import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import GetInTouchModal from './landing/GetInTouchModal';
import DemoBanner from './DemoBanner';

const NAV_ITEMS = [
  { label: 'Programs', href: '#services' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [leadModalOpen, setLeadModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (href) => {
    setOpen(false);
    if (href.startsWith('/')) {
      navigate(href);
      return;
    }
    if (location.pathname === '/') {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/${href}`);
    }
  };

  const openLeadModal = () => {
    setOpen(false);
    setLeadModalOpen(true);
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <DemoBanner />
      <nav data-testid="navbar" className="bg-white/95 backdrop-blur-md border-b border-[#E1E7EF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-16">
        <button onClick={() => navigate('/')} data-testid="nav-logo" className="flex items-center gap-2 font-heading font-bold text-xl text-[#0056D2]">
          <img src="/logo.svg" alt="A7 Logo" className="w-8 h-8" />
          A7 Globetech
        </button>
        <div className="hidden md:flex items-center gap-7">
          {NAV_ITEMS.map(item => (
            <button
              key={item.label}
              onClick={() => scrollTo(item.href)}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="font-body text-sm font-medium text-[#585858] hover:text-[#0056D2] transition-colors"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={openLeadModal}
            data-testid="nav-get-in-touch"
            className="font-body text-sm font-semibold text-white px-5 py-2.5 rounded-xl bg-[#62CED3] hover:bg-[#48BFC5] transition-colors"
          >
            Get in Touch with us
          </button>
        </div>
        <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" className="md:hidden p-2">
          {open ? <X className="w-5 h-5 text-[#1F1F1F]" /> : <Menu className="w-5 h-5 text-[#1F1F1F]" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-white border-b border-[#E1E7EF] px-6 py-4 space-y-3">
          {NAV_ITEMS.map(item => (
            <button
              key={item.label}
              onClick={() => scrollTo(item.href)}
              className="block w-full text-left font-body text-sm font-medium text-[#585858] hover:text-[#0056D2] py-1"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={openLeadModal}
            data-testid="nav-get-in-touch-mobile"
            className="block w-full text-center font-body text-sm font-semibold text-white px-5 py-2.5 rounded-xl bg-[#62CED3] hover:bg-[#48BFC5] transition-colors"
          >
            Get in Touch with us
          </button>
        </div>
      )}
      {leadModalOpen && <GetInTouchModal onClose={() => setLeadModalOpen(false)} />}
      </nav>
    </div>
  );
}
